import React from 'react'
import listImg from "../assets/images/DRONE_BANANA_ISLAND_MASTER.png"
import { IoCloseOutline } from "react-icons/io5";
import { HiDownload } from "react-icons/hi";

function ImagePopups({selectData, cancelPopup}) {

  return (

    <div className="modal-wrapper modal-scroll">
      <div className="modal-popup modal-lg">
        <div className="modal-innerpopup ">
          <div className="modal-headdiv d-flex justify-content-between">
            {/* <h5 className="main-head mb-1 text-white">Details</h5> */}
            <span className="closeBtn"><IoCloseOutline size={32} onClick={() => cancelPopup()} /></span>
          </div>
          <div className="modal-body-wrapper">
            <div className='row'>
              <div className='col-md-12'>
                {selectData.fileTypeId == 2 ?
                <div className='video-popup'>
                <video controls autoPlay class="object-fit-contain"
                  onContextMenu={(event)=>event.preventDefault()}
                  poster={selectData?.thumbnail_image}>
                  <source 
                  src={selectData?.qualityTypeArray.find(item => item.qualitytype === "low")?.qualityvideoname || 
                    selectData.url
                  } 
                  type="video/mp4"/>
                  Your browser does not support HTML5 video.
                </video>
                </div>
                :
                <div className='image-all-popup-height'>
                  <img src={selectData.url} className="card-img-top mb-3" alt="..." 
                  onContextMenu={(event)=>event.preventDefault()}/>
                </div>
                }
              </div>
              {/* <div className='col-md-4 row row-cols-2 row-cols-md-1 g-2 g-md-0'>
                {Array.from({length: 2}).map((_, i) => (

                <div className="list-sub col mb-2">
                  <div className="card">
                    <HiDownload className='list-download' size={18}/>
                    <img src={listImg} className="card-img-top" alt="..." />
                  </div>
                </div>
                ))}
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ImagePopups